import { render, staticRenderFns } from "./ModalDesignLayout.vue?vue&type=template&id=5bc8be48&scoped=true&"
import script from "./ModalDesignLayout.vue?vue&type=script&lang=js&"
export * from "./ModalDesignLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalDesignLayout.vue?vue&type=style&index=0&id=5bc8be48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8be48",
  null
  
)

export default component.exports